/* THE KEYBOARD. Every action in the console is reachable by Tab and Enter, and a few keys save the walk: `/` or `:` goes to
   the command line, `?` lists the keys, Esc closes whatever is open. Pure: a key event's facts in, the action out, so
   the rules are tested without a browser; the browser end is ui/keys.tsx and the command line. */

export type KeyFacts = { key: string; metaKey: boolean; ctrlKey: boolean; altKey: boolean; typing: boolean }
export type KeyAction = 'command' | 'keys' | 'close'

export type Shortcut = { keys: string[]; does: string }

/** What the keys panel lists, in this order. */
export const SHORTCUTS: Shortcut[] = [
  { keys: ['Left', 'Right', 'N', 'P'], does: 'Send the agent to the previous or the next case, or bed if one is open.' },
  { keys: ['/', ':'], does: 'Open the command line.' },
  { keys: ['Ctrl K', 'Cmd K'], does: 'Open the command line, from a field too.' },
  { keys: ['?'], does: 'Show or hide this list.' },
  { keys: ['Esc'], does: 'Close what is open: the command line’s list, an open section, this list.' },
  { keys: ['Tab', 'Shift Tab'], does: 'Move to the next or the previous action. The ring shows where you are.' },
  { keys: ['Enter'], does: 'Do the action you are on; in the command line, run the line.' },
  { keys: ['Up', 'Down'], does: 'In the command line, pick one of its matches.' },
]

/** The action a key means, or null when it means nothing here. A key typed into a field is the field's own, but for Ctrl or Cmd K and Esc. */
export function actionFor(e: KeyFacts): KeyAction | null {
  const chord = e.metaKey || e.ctrlKey
  if (chord && e.key.toLowerCase() === 'k' && !e.altKey) return 'command'
  if (chord || e.altKey) return null
  if (e.key === 'Escape') return 'close'
  if (e.typing) return null
  if (e.key === '/' || e.key === ':') return 'command'
  if (e.key === '?') return 'keys'
  return null
}

/** Whether a key event's target is a place the reader types. */
export function isTyping(target: EventTarget | null): boolean {
  return target instanceof HTMLElement && target.closest('input, textarea, select, [contenteditable]') !== null
}
